import React, { useState } from 'react';
import { Button, Box, Typography } from '@mui/material';
import articleApi from '../services/articleApi';

const ImageUploadTest = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      console.log('Selected file:', selectedFile.name, selectedFile.type, selectedFile.size);
      setFile(selectedFile);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      alert('請選擇文件');
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('title', '測試圖片上傳');
      formData.append('content', '這是一個測試');
      formData.append('tags', '測試');
      formData.append('is_published', 'true');
      formData.append('image', file);

      console.log('FormData contents:');
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      const result = await articleApi.createArticle(formData);
      console.log('Upload successful:', result);
      alert('上傳成功！');
    } catch (error) {
      console.error('Upload error:', error);
      alert('上傳失敗：' + (error.response?.data?.detail || error.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>圖片上傳測試</Typography>
      
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        style={{ marginBottom: '16px' }}
      />
      
      {file && (
        <Box sx={{ mb: 2 }}>
          <Typography>選擇的文件：{file.name}</Typography>
          <Typography>文件類型：{file.type}</Typography>
          <Typography>文件大小：{file.size} bytes</Typography>
        </Box>
      )}
      
      <Button
        variant="contained"
        onClick={handleUpload}
        disabled={!file || loading}
      >
        {loading ? '上傳中...' : '上傳測試'}
      </Button>
    </Box>
  );
};

export default ImageUploadTest;
